export { default } from './DetailedCarMoreDetails';
